import { MDBRow, MDBCol } from "mdb-react-ui-kit";
import MissionImg from "../asset/images/BGImages/mission.jpg";
export default function mission(props) {
    return (
        <div className="w-100" style={{ height: "50%", backgroundColor: "#ffffff" }} id="mission">
            <MDBRow className="mx-0" style={{ height: "100%", overflowY: "auto" }} id="lRow">
                <MDBCol lg="6" className="h-100 d-none d-lg-flex d-xl-flex d-xxl-flex justify-content-center align-items-center py-3" id="lCol">
                    <img src={MissionImg} className="rounded-5" style={{ height: "100%", width: "100%", objectFit: "cover" }} />
                </MDBCol>
                <MDBCol lg="6" className="h-100 d-flex flex-column justify-content-center align-items-center" id="lCol">
                    <h2 className=" display-5 fw-bold text-start theme-color py-3 w-75 mb-4">Our Mission</h2>
                    <p className="fs-3 w-75">
                        To help those who are at the bottom of the pyramid. To work with vigour,
                        dedication and innovation to achieve excellence in service,
                        quality, reliability, safety and customer care as the ultimate goal. To earn the trust and
                        confidence of all stakeholders, exceeding their expectations and making the Company a respected household name.
                    </p>
                </MDBCol>
                <MDBCol lg="6" className="h-100 d-flex d-lg-none d-xl-none d-xxl-none justify-content-center align-items-center py-3" id="lCol">
                    <img src={MissionImg} className="rounded-5" style={{ height: "100%", width: "100%", objectFit: "cover" }} />
                </MDBCol>
            </MDBRow>
        </div>
    )
}